import { IconWrapper } from '../runtime';
export default IconWrapper('triangle-right', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M6.02388 11.3974C5.57757 11.6763 5 11.3538 5 10.8257L5 5.1739C5 4.65395 5.5623 4.33063 6.00896 4.59322C7.70642 5.59114 8.96194 6.32925 10.6682 7.33234C11.1035 7.58824 11.1123 8.21756 10.684 8.48519L6.02388 11.3974Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});